import { render, staticRenderFns } from "./platbody.vue?vue&type=template&id=30364d25&scoped=true&"
import script from "./platbody.vue?vue&type=script&lang=js&"
export * from "./platbody.vue?vue&type=script&lang=js&"
import style0 from "./platbody.vue?vue&type=style&index=0&id=30364d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30364d25",
  null
  
)

export default component.exports